/* eslint-disable react/prefer-stateless-function */
/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */

import React from 'react';
import { decorate } from 'mobx';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

// expected props
// - userStore (via injection)
class Declaimer extends React.Component {
  render() {
    return (
      <div className="declaimer">
        {/* <div className="powered-by-text">Powered by RACE</div> */}
        <img className="powered-by-logo" src={this.props.assets.images.poweredByRACEWide1} alt="Powered by RMIT RACE" />
      </div>
    );
  }
}

// see https://medium.com/@mweststrate/mobx-4-better-simpler-faster-smaller-c1fbc08008da
decorate(Declaimer, {});

export default inject('assets')(withRouter(observer(Declaimer)));
